import React from "react";

/*
  A `backticked` span inside a CVE description becomes inline code. The /cve
  list page and the preview on the home page render the same strings out of
  src/Components/Pages/AboutMe/CVE/data.js, so the renderer lives here instead
  of being written twice.
*/

export const withInlineCode = (text = "") =>
  text
    .split("`")
    .map((part, i) => (i % 2 === 1 ? <code key={i}>{part}</code> : part));
